import { render } from "./index.vue?vue&type=template&id=614c2caa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render

export default script